
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../AddItem/AddItem.st.css.js";
import "../Foundation/stylable/default-scroll-bar.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_130_0_TimeTable";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_130_0_TimeTable__root","text-medium-thin":"wds_1_130_0_StylableTypography__text-medium-thin","text-medium-normal":"wds_1_130_0_StylableTypography__text-medium-normal","text-medium-bold":"wds_1_130_0_StylableTypography__text-medium-bold","text-tiny-normal":"wds_1_130_0_StylableTypography__text-tiny-normal","text-tiny-thin":"wds_1_130_0_StylableTypography__text-tiny-thin","text-tiny-bold":"wds_1_130_0_StylableTypography__text-tiny-bold","defaultScrollBar":"wds_1_130_0_defaultscrollbar__defaultScrollBar","column":"wds_1_130_0_TimeTable__column","header":"wds_1_130_0_TimeTable__header","title":"wds_1_130_0_TimeTable__title","subtitle":"wds_1_130_0_TimeTable__subtitle","item":"wds_1_130_0_TimeTable__item","actionsContainer":"wds_1_130_0_TimeTable__actionsContainer","addItemButton":"wds_1_130_0_TimeTable__addItemButton","addItemLabel":"wds_1_130_0_TimeTable__addItemLabel","headerContainer":"wds_1_130_0_TimeTable__headerContainer","contentContainer":"wds_1_130_0_TimeTable__contentContainer","content":"wds_1_130_0_TimeTable__content"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"headerHeight":"59px","columnHeaderMargin":"6px","addItemPlaceholder":"36px"}; 
export var vars = {}; 




